export default __webpack_public_path__ + "static/media/new-message.01bfd32f.mp3";